import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  setSelectedVehiclesTab,
  vehiclesSelectedTabSelector,
  vehiclesTabsSelector,
} from "@/domains/estate/slice";

export default function EstateVehiclesTabsContainer() {
  const { t } = useTranslation("estate");
  const dispatch = useDispatch();
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  const vehiclesTabs = useAppSelector(vehiclesTabsSelector);
  const selectedVehiclesTab = useAppSelector(vehiclesSelectedTabSelector);
  const [activeTabBlockStyle, setActiveTabBlockStyle] = useState({ width: 0, left: 0 });
  const refs = useRef([]);

  useLayoutEffect(() => {
    const index = vehiclesTabs.findIndex((tab) => tab === selectedVehiclesTab);
    if (refs.current[index]) {
      const activeTabElement = refs.current[index];
      const { offsetWidth, offsetLeft } = activeTabElement;

      setActiveTabBlockStyle({ width: offsetWidth, left: offsetLeft });
    }
  }, [selectedVehiclesTab, vehiclesTabs]);

  useEffect(() => setIsFirstOpen(false), []);

  return (
    <div className="relative h-[2.75rem] flex items-center w-full bg-dark-800 rounded-[0.5rem]">
      {vehiclesTabs.map((tab, index) => (
        <button
          type="button"
          key={tab}
          ref={(el) => {
            refs.current[index] = el;
            return el;
          }}
          className={clsx(
            "h-full px-5 hover:text-white transition-all duration-300 text-11 font-bold z-1 uppercase",
            selectedVehiclesTab === tab ? "text-white" : "text-white/50",
          )}
          onClick={() => dispatch(setSelectedVehiclesTab(tab))}
        >
          {t(`estate.vehicles.tab.${tab.toLowerCase()}`)}
        </button>
      ))}

      <div
        className="absolute h-full bg-gradient-red rounded-[0.5rem] duration-300 z-0"
        style={{
          width: `${activeTabBlockStyle.width}px`,
          transform: `translateX(${activeTabBlockStyle.left}px)`,
          transitionProperty: isFirstOpen ? "none" : "all",
        }}
      />
    </div>
  );
}
